module.exports = __webpack_public_path__ + "img/011-partnership.1dc8b5be.svg";